import { get } from 'lodash'

export const isStepActive = (steps, id) =>
  get(
    steps.find(step => step.id === id),
    'active',
    false
  ) === true
